/* ==========================================================================
   CoZzzy — panier latéral
   - Ajout au panier sans « chargement » : le bouton se transforme en petite
     boule qui file en arc de cercle vers l'icône panier, puis le panier
     s'ouvre sur le côté.
   - Le contenu du panier est ré-affiché par l'API Section Rendering
     (section « cz-cart-drawer »).
   API : window.CzCart.add(items, { source }), .open(), .close(), .refresh()
   ========================================================================== */
(function () {
  'use strict';

  var SECTION = 'cz-cart-drawer';
  var docEl = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function rootUrl() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }
  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function drawer() { return $('[data-czc]'); }
  function reflow(el) { return el && el.offsetWidth; }

  /* Dernier appui (pour partir de l'endroit exact du clic) */
  var lastPointer = null;
  document.addEventListener('pointerdown', function (e) {
    lastPointer = { x: e.clientX, y: e.clientY, target: e.target, time: Date.now() };
  }, true);

  /* ------------------------------------------------------------------------
     Ouverture / fermeture
     ------------------------------------------------------------------------ */
  var lastFocus = null;
  var celebrateTimer = null;

  function isOpen() {
    var d = drawer();
    return !!(d && d.classList.contains('is-open'));
  }

  function setExpanded(on) {
    $$('[data-czc-open]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }

  function open(opts) {
    opts = opts || {};
    var d = drawer();
    if (!d) return;
    if (!isOpen()) lastFocus = opts.returnFocus || document.activeElement;
    d.removeAttribute('inert');
    d.setAttribute('aria-hidden', 'false');

    clearTimeout(celebrateTimer);
    d.classList.remove('is-celebrate');
    if (opts.celebrate && !reduceMotion.matches) {
      reflow(d);
      d.classList.add('is-celebrate');
      celebrateTimer = setTimeout(function () { d.classList.remove('is-celebrate'); }, 2200);
    }

    reflow(d);
    d.classList.add('is-open');
    docEl.classList.add('czc-lock');
    setExpanded(true);

    var panel = $('[data-czc-panel]', d);
    setTimeout(function () {
      if (!isOpen() || !panel) return;
      panel.focus({ preventScroll: true });
    }, 90);
  }

  function close() {
    var d = drawer();
    if (!d || !isOpen()) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    d.setAttribute('inert', '');
    docEl.classList.remove('czc-lock');
    setExpanded(false);
    var f = lastFocus;
    lastFocus = null;
    if (f && f.focus && document.contains(f)) f.focus({ preventScroll: true });
  }

  /* Garder le focus dans le panier ouvert */
  function focusables(scope) {
    return $$('a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])', scope)
      .filter(function (el) { return el.getClientRects().length > 0; });
  }

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var panel = $('[data-czc-panel]', drawer());
    var list = focusables(panel);
    if (!list.length) { e.preventDefault(); panel.focus(); return; }
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || active === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  });

  /* ------------------------------------------------------------------------
     Affichage
     ------------------------------------------------------------------------ */
  function setCount(n, pop) {
    $$('[data-czc-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = !n;
      if (pop && n && !reduceMotion.matches) {
        el.classList.remove('is-pop');
        reflow(el);
        el.classList.add('is-pop');
      }
    });
    $$('[data-czc-open]').forEach(function (b) {
      b.setAttribute('aria-label', n ? 'Panier, ' + n + (n > 1 ? ' articles' : ' article') : 'Panier');
    });
  }

  function focusKey(el) {
    var d = drawer();
    if (!el || !d || !d.contains(el)) return null;
    if (el.hasAttribute('data-czc-dir')) return '[data-line="' + el.getAttribute('data-line') + '"][data-czc-dir="' + el.getAttribute('data-czc-dir') + '"]';
    if (el.hasAttribute('data-czc-close')) return '.czc__close';
    return null;
  }

  function restoreFocus(key) {
    var d = drawer();
    if (!d || !isOpen()) return;
    var el = key ? $(key, d) : null;
    if (!el) el = $('[data-czc-panel]', d);
    if (el) el.focus({ preventScroll: true });
  }

  function render(html) {
    var d = drawer();
    if (!d || !html) return parseInt(d ? d.getAttribute('data-count') : '0', 10) || 0;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var freshRoot = $('[data-czc]', tmp);
    var fresh = $('[data-czc-inner]', tmp);
    var cur = $('[data-czc-inner]', d);
    if (fresh && cur) {
      var sc = $('[data-czc-scroll]', cur);
      var top = sc ? sc.scrollTop : 0;
      cur.parentNode.replaceChild(fresh, cur);
      var nsc = $('[data-czc-scroll]', fresh);
      if (nsc) nsc.scrollTop = top;
    }
    var n = freshRoot ? (parseInt(freshRoot.getAttribute('data-count'), 10) || 0) : 0;
    d.setAttribute('data-count', String(n));
    initUpsell(d);
    return n;
  }

  function announce(msg) {
    var el = $('[data-czc-live]');
    if (!el) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 50);
  }

  var toastTimer = null;
  function toast(msg) {
    var el = $('[data-czc-toast]');
    if (!el || !msg) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 5000);
  }

  function markNew(json) {
    var d = drawer();
    var items = json && json.items ? json.items : [];
    items.forEach(function (it) {
      if (!it || !it.key) return;
      var key = window.CSS && CSS.escape ? CSS.escape(it.key) : it.key;
      var li = $('[data-czc-line][data-key="' + key + '"]', d);
      if (li) li.classList.add('is-new');
    });
  }

  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  /* ------------------------------------------------------------------------
     Requêtes panier (avec la section du panier dans la même réponse)
     ------------------------------------------------------------------------ */
  function cartPost(path, body) {
    body = body || {};
    body.sections = SECTION;
    body.sections_url = window.location.pathname;
    return fetch(rootUrl() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || (j && j.status && Number(j.status) >= 400)) {
          var msg = j && (j.description || j.message);
          throw new Error(typeof msg === 'string' ? msg : '');
        }
        return j;
      });
    });
  }

  /* Redessine le panier depuis la réponse, ou le recharge si la réponse ne le contient pas */
  function renderFrom(j) {
    var html = j && j.sections && j.sections[SECTION];
    if (html) return Promise.resolve(render(html));
    return loadSection().catch(function () { return render(null); });
  }

  function loadSection() {
    return fetch(rootUrl() + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { return render(j && j[SECTION]); });
  }

  function refresh() {
    return loadSection()
      .then(function (n) { setCount(n); return n; })
      .catch(function () {});
  }

  function addedText(items) {
    var names = (items || []).map(function (it) { return it.product_title; }).filter(Boolean);
    if (!names.length) return 'Article ajouté au panier.';
    return names.join(' et ') + (names.length > 1 ? ' ajoutés au panier.' : ' ajouté au panier.');
  }

  function changeLine(line, qty, btn) {
    var li = btn && btn.closest('[data-czc-line]');
    if (li) li.classList.add('is-busy');
    var key = focusKey(document.activeElement);
    return cartPost('cart/change.js', { line: line, quantity: qty })
      .then(function (j) {
        return renderFrom(j).then(function (n) {
          setCount(n);
          restoreFocus(key);
          announce(qty === 0 ? 'Article retiré du panier.' : 'Quantité mise à jour.');
          dispatch('czc:updated', { cart: j });
        });
      })
      .catch(function (err) {
        if (li) li.classList.remove('is-busy');
        toast((err && err.message) || 'Oups, la mise à jour n’a pas fonctionné. Réessayez.');
      });
  }

  /* ------------------------------------------------------------------------
     Animation : clic, petite boule en arc de cercle, rebond du panier
     ------------------------------------------------------------------------ */
  function press(btn, ev) {
    if (!btn || reduceMotion.matches) return;
    btn.classList.remove('czc-press');
    reflow(btn);
    btn.classList.add('czc-press');
    setTimeout(function () { btn.classList.remove('czc-press'); }, 420);

    var r = btn.getBoundingClientRect();
    var x = r.width / 2;
    var y = r.height / 2;
    var p = ev && ev.clientX ? { x: ev.clientX, y: ev.clientY } : null;
    if (!p && lastPointer && Date.now() - lastPointer.time < 1500 && btn.contains(lastPointer.target)) p = lastPointer;
    if (p) { x = p.x - r.left; y = p.y - r.top; }
    var size = Math.max(r.width, r.height) * 2.2;
    var wrap = document.createElement('span');
    wrap.className = 'czc-ripple';
    wrap.setAttribute('aria-hidden', 'true');
    var dot = document.createElement('span');
    dot.className = 'czc-ripple__dot';
    dot.style.width = size + 'px';
    dot.style.height = size + 'px';
    dot.style.left = (x - size / 2) + 'px';
    dot.style.top = (y - size / 2) + 'px';
    wrap.appendChild(dot);
    btn.appendChild(wrap);
    setTimeout(function () { wrap.remove(); }, 700);
  }

  function visibleTarget() {
    var best = null;
    $$('[data-czc-target]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width < 8 || r.height < 8) return;
      if (r.bottom <= 0 || r.top >= window.innerHeight || r.right <= 0 || r.left >= window.innerWidth) return;
      var node = el;
      var alpha = 1;
      while (node && node.nodeType === 1 && node !== document.body) {
        var cs = window.getComputedStyle(node);
        if (cs.visibility === 'hidden' || cs.display === 'none') return;
        var o = parseFloat(cs.opacity);
        alpha *= isNaN(o) ? 1 : o;
        node = node.parentElement;
      }
      if (alpha < 0.6) return;
      best = el;
    });
    return best;
  }

  function bump(el) {
    if (!el || reduceMotion.matches) return;
    var icon = el.querySelector('.czh-cart-icon') || el;
    icon.classList.remove('czc-bump');
    reflow(icon);
    icon.classList.add('czc-bump');
    setTimeout(function () { icon.classList.remove('czc-bump'); }, 650);
  }

  var forcedBar = null;
  function releaseBar() {
    if (forcedBar) { forcedBar.classList.remove('is-forced'); forcedBar = null; }
  }

  function solidColor(c) {
    return c && c !== 'transparent' && !/rgba\([^)]*,\s*0\)$/.test(c);
  }

  /* Copie visuelle du bouton (sans ses attributs), posée au-dessus de lui */
  function cloneButton(source, s, cs) {
    var c = source.cloneNode(true);
    [c].concat($$('*', c)).forEach(function (n) {
      if (!n.attributes) return;
      Array.prototype.slice.call(n.attributes).forEach(function (a) {
        if (a.name === 'id' || a.name === 'name' || a.name === 'for' || a.name === 'form' || a.name.indexOf('data-') === 0 || a.name.indexOf('aria-') === 0) n.removeAttribute(a.name);
      });
    });
    $$('.czc-ripple', c).forEach(function (n) { n.remove(); });
    c.removeAttribute('disabled');
    c.setAttribute('aria-hidden', 'true');
    c.setAttribute('tabindex', '-1');
    var st = c.style;
    st.cssText = '';
    st.setProperty('position', 'fixed', 'important');
    st.setProperty('left', '0', 'important');
    st.setProperty('top', '0', 'important');
    st.setProperty('margin', '0', 'important');
    st.setProperty('z-index', '2147483000', 'important');
    st.setProperty('pointer-events', 'none', 'important');
    st.setProperty('box-sizing', 'border-box', 'important');
    st.setProperty('overflow', 'hidden', 'important');
    st.setProperty('white-space', 'nowrap', 'important');
    st.setProperty('transition', 'none', 'important');
    st.setProperty('animation', 'none', 'important');
    st.setProperty('display', cs.display === 'inline' ? 'inline-flex' : cs.display, 'important');
    st.setProperty('align-items', cs.alignItems);
    st.setProperty('justify-content', cs.justifyContent);
    st.setProperty('gap', cs.gap);
    st.setProperty('padding', '0', 'important');
    st.setProperty('border', cs.border, 'important');
    st.setProperty('background', cs.backgroundColor, 'important');
    st.setProperty('color', cs.color, 'important');
    st.setProperty('font', cs.font, 'important');
    st.setProperty('letter-spacing', cs.letterSpacing);
    st.setProperty('box-shadow', 'none', 'important');
    st.setProperty('min-height', '0', 'important');
    st.setProperty('min-width', '0', 'important');
    st.setProperty('max-width', 'none', 'important');
    /* Propriétés animées : surtout pas en !important (l'animation ne pourrait pas les changer) */
    st.width = s.width + 'px';
    st.height = s.height + 'px';
    st.borderRadius = cs.borderRadius;
    st.transform = 'translate(' + s.left + 'px,' + s.top + 'px)';
    return c;
  }

  function fly(source, delay) {
    var resolveDone;
    var ctl = { done: new Promise(function (res) { resolveDone = res; }), cancel: function () {} };
    var targetEl = visibleTarget();

    /* Pas de vol si le panier visé est dans le bouton lui-même (bouton de la barre produit) */
    if (!source || reduceMotion.matches || !document.body.animate || (targetEl && source.contains(targetEl))) {
      bump(targetEl);
      resolveDone();
      return ctl;
    }

    /* Aucun panier visible (îlot hors écran) : on fait apparaître la barre produit et son panier */
    if (!targetEl) {
      var bar = $('[data-czh-sticky-bar]');
      if (bar && bar.querySelector('[data-czc-target]')) {
        bar.classList.add('is-forced');
        forcedBar = bar;
      }
    }

    var anims = [];
    var nodes = [];
    var cancelled = false;
    var srcAnim = null;
    var timer = null;
    function cleanup() { nodes.forEach(function (n) { n.remove(); }); nodes = []; }
    ctl.cancel = function () {
      if (cancelled) return;
      cancelled = true;
      clearTimeout(timer);
      anims.forEach(function (a) { try { a.cancel(); } catch (e) {} });
      if (srcAnim) { try { srcAnim.cancel(); } catch (e) {} }
      cleanup();
      resolveDone();
    };
    timer = setTimeout(begin, delay || 0);
    return ctl;

    function begin() {
    if (cancelled) return;
    var s = source.getBoundingClientRect();
    if (!s.width || !s.height) { resolveDone(); return; }

    var cs = window.getComputedStyle(source);
    var bg = solidColor(cs.backgroundColor) ? cs.backgroundColor : '#b5371e';
    var ring = cs.color || '#ffffff';
    var radius = cs.borderRadius || '999px';
    var B = window.innerWidth < 600 ? 22 : 26;
    var cx = s.left + s.width / 2;
    var cy = s.top + s.height / 2;

    /* 1. Le bouton se resserre en petite boule (le vrai bouton revient juste après) */
    var clone = cloneButton(source, s, cs);
    document.body.appendChild(clone);
    nodes.push(clone);
    Array.prototype.slice.call(clone.childNodes).forEach(function (k) {
      if (k.nodeType === 1) anims.push(k.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 130, easing: 'ease-out', fill: 'forwards' }));
    });
    srcAnim = source.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 60, fill: 'forwards' });

    var shrink = clone.animate([
      { width: s.width + 'px', height: s.height + 'px', borderRadius: radius, transform: 'translate(' + s.left + 'px,' + s.top + 'px)' },
      { width: B + 'px', height: B + 'px', borderRadius: (B / 2) + 'px', transform: 'translate(' + (cx - B / 2) + 'px,' + (cy - B / 2) + 'px)' }
    ], { duration: 280, easing: 'cubic-bezier(.5, 0, .25, 1)', fill: 'forwards' });
    anims.push(shrink);

    /* Le vrai bouton réapparaît en douceur pendant que la boule se forme */
    setTimeout(function () {
      if (cancelled || !srcAnim) return;
      try { srcAnim.cancel(); } catch (e) {}
      srcAnim = null;
      source.animate([{ opacity: 0, transform: 'scale(.9)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 380, easing: 'cubic-bezier(.34, 1.56, .64, 1)' });
    }, 190);

    shrink.onfinish = function () {
      if (cancelled) return;
      if (srcAnim) { try { srcAnim.cancel(); } catch (e) {} srcAnim = null; }

      /* La boule (avec un liseré pour rester visible partout) */
      var ball = document.createElement('span');
      ball.className = 'czc-fly';
      ball.setAttribute('aria-hidden', 'true');
      ball.style.background = bg;
      ball.style.setProperty('--czc-ring', ring);
      ball.style.width = B + 'px';
      ball.style.height = B + 'px';
      ball.style.borderRadius = '50%';
      ball.style.transform = 'translate(' + (cx - B / 2) + 'px,' + (cy - B / 2) + 'px)';
      document.body.appendChild(ball);
      nodes.push(ball);
      clone.remove();

      /* La cible peut avoir bougé (barre qui apparaît, etc.) : on la relit maintenant */
      var tEl = visibleTarget() || targetEl;
      var t = tEl ? tEl.getBoundingClientRect() : { left: window.innerWidth - 60, top: 14, width: 44, height: 44 };
      var tx = t.left + t.width / 2;
      var ty = t.top + t.height / 2;

      /* 2. Elle file en arc de cercle vers le panier :
            point de contrôle décalé perpendiculairement au trajet, côté écran */
      var dx = tx - cx;
      var dy = ty - cy;
      var dist = Math.sqrt(dx * dx + dy * dy) || 1;
      var off = Math.min(220, Math.max(70, dist * 0.35));
      var mx = (cx + tx) / 2;
      var my = (cy + ty) / 2;
      var vw = window.innerWidth;
      var vh = window.innerHeight;
      var best = null;
      [[-dy / dist, dx / dist], [dy / dist, -dx / dist]].forEach(function (n) {
        var px = mx + n[0] * off;
        var py = my + n[1] * off;
        var score = n[1] * 60 + Math.sqrt((px - vw / 2) * (px - vw / 2) + (py - vh / 2) * (py - vh / 2)) * 0.05;
        if (py < 24 || px < 12 || px > vw - 12) score += 1000;
        if (!best || score < best.score) best = { x: px, y: py, score: score };
      });
      var x1 = best.x;
      var y1 = Math.max(6, best.y);
      var N = 32;
      var frames = [];
      for (var i = 0; i <= N; i++) {
        var u = i / N;
        var iu = 1 - u;
        var x = iu * iu * cx + 2 * iu * u * x1 + u * u * tx;
        var y = iu * iu * cy + 2 * iu * u * y1 + u * u * ty;
        var sc = u < 0.12 ? 1 + 0.18 * Math.sin((u / 0.12) * Math.PI) : 1 - 0.48 * Math.pow((u - 0.12) / 0.88, 2);
        frames.push({ transform: 'translate(' + (x - B / 2).toFixed(1) + 'px,' + (y - B / 2).toFixed(1) + 'px) scale(' + sc.toFixed(3) + ')', offset: u });
      }
      var dur = Math.round(Math.min(860, Math.max(420, 380 + dist * 0.5)));
      var easing = 'cubic-bezier(.4, .1, .45, 1)';
      var main = ball.animate(frames, { duration: dur, easing: easing, fill: 'forwards' });
      anims.push(main);

      /* Petite traînée */
      [0.45, 0.24].forEach(function (op, k) {
        var g = document.createElement('span');
        g.className = 'czc-fly czc-fly--ghost';
        g.setAttribute('aria-hidden', 'true');
        g.style.width = B + 'px';
        g.style.height = B + 'px';
        g.style.borderRadius = '50%';
        g.style.background = bg;
        g.style.opacity = String(op);
        document.body.appendChild(g);
        nodes.push(g);
        var factor = 0.7 - k * 0.18;
        var gf = frames.map(function (f) {
          return {
            transform: f.transform.replace(/scale\(([\d.]+)\)/, function (m, v) { return 'scale(' + (parseFloat(v) * factor).toFixed(3) + ')'; }),
            offset: f.offset
          };
        });
        anims.push(g.animate(gf, { duration: dur, easing: easing, delay: 50 * (k + 1), fill: 'both' }));
      });

      /* 3. Arrivée : la boule plonge dans le panier, qui rebondit */
      main.onfinish = function () {
        if (cancelled) return;
        var end = frames[N].transform;
        var land = ball.animate([
          { transform: end, opacity: 1 },
          { transform: end.replace(/scale\([\d.]+\)/, 'scale(0.1)'), opacity: 0 }
        ], { duration: 170, easing: 'ease-in', fill: 'forwards' });
        anims.push(land);
        bump(tEl);
        setTimeout(function () { if (!cancelled) resolveDone(); }, 140);
        land.onfinish = function () { cleanup(); };
      };
    };
    }
  }

  /* ------------------------------------------------------------------------
     Ajout au panier (utilisé par les pages produit)
     ------------------------------------------------------------------------ */
  var adding = false;

  function add(items, opts) {
    opts = opts || {};
    if (adding) return Promise.reject(new Error('busy'));
    adding = true;
    var source = opts.source || null;
    press(source, opts.event);
    var flight = fly(source, 110);

    return cartPost('cart/add.js', { items: items })
      .then(function (j) {
        return flight.done.then(function () { return renderFrom(j); }).then(function (n) {
          setCount(n, true);
          markNew(j);
          open({ celebrate: true, returnFocus: source });
          releaseBar();
          announce(addedText(j.items));
          adding = false;
          dispatch('czc:added', { items: j.items || [] });
          return j;
        });
      })
      .catch(function (err) {
        flight.cancel();
        releaseBar();
        adding = false;
        throw err;
      });
  }

  /* ------------------------------------------------------------------------
     Suggestion One ↔ Mini dans le panier
     ------------------------------------------------------------------------ */
  function initUpsell(scope) {
    var box = $('[data-czc-upsell]', scope);
    if (!box || box.__czcReady) return;
    box.__czcReady = true;
    var dataEl = $('[data-czc-up-data]', box);
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var addBtn = $('[data-czc-up-add]', box);
    var priceEl = $('[data-czc-up-price]', box);
    var media = $('[data-czc-up-media]', box);
    var sizeSel = $('[data-czc-up-size]', box);
    var swatches = $$('[data-czc-up-colour]', box);
    var checked = swatches.filter(function (sw) { return sw.getAttribute('aria-checked') === 'true'; })[0] || swatches[0];
    var state = {
      colour: checked ? checked.getAttribute('data-czc-up-colour') : null,
      size: sizeSel ? sizeSel.value : null
    };

    function find() {
      return data.variants.filter(function (v) {
        if (state.colour && v.options[data.colourIndex] !== state.colour) return false;
        if (data.sizeIndex >= 0 && state.size && v.options[data.sizeIndex] !== state.size) return false;
        return true;
      })[0];
    }

    function sync() {
      var v = find();
      if (!addBtn) return;
      if (!v) { addBtn.disabled = true; return; }
      addBtn.disabled = !v.available;
      addBtn.setAttribute('data-variant', v.id);
      if (priceEl) priceEl.textContent = v.price;
      if (media && v.arch) media.style.setProperty('--czc-arch', v.arch);
      var img = media && media.querySelector('img');
      if (img && v.img && img.getAttribute('data-czc-src') !== v.img) {
        img.setAttribute('data-czc-src', v.img);
        media.classList.add('is-swapping');
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          if (img.getAttribute('data-czc-src') !== v.img) return;
          img.removeAttribute('srcset');
          img.src = v.img;
          media.classList.remove('is-swapping');
        };
        pre.src = v.img;
      }
    }

    function choose(sw, focus) {
      swatches.forEach(function (o) {
        var on = o === sw;
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        o.setAttribute('tabindex', on ? '0' : '-1');
      });
      state.colour = sw.getAttribute('data-czc-up-colour');
      if (focus) sw.focus();
      sync();
    }

    swatches.forEach(function (sw, i) {
      sw.setAttribute('tabindex', sw === checked ? '0' : '-1');
      sw.addEventListener('click', function () { choose(sw, false); });
      sw.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = swatches[(i + 1) % swatches.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = swatches[(i - 1 + swatches.length) % swatches.length];
        if (next) { e.preventDefault(); choose(next, true); }
      });
    });
    if (sizeSel) sizeSel.addEventListener('change', function () { state.size = sizeSel.value; sync(); });

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        var id = parseInt(addBtn.getAttribute('data-variant'), 10);
        if (!id || adding) return;
        adding = true;
        press(addBtn, e);
        addBtn.disabled = true;
        /* ss_bundle_skip : l'appli de bundle (Section Store) ne doit pas transformer cet ajout */
        cartPost('cart/add.js', { items: [{ id: id, quantity: 1 }], ss_bundle_skip: '1' })
          .then(function (j) {
            return renderFrom(j).then(function (n) {
              adding = false;
              setCount(n, true);
              markNew(j);
              bump(visibleTarget());
              var d = drawer();
              var sc = d && $('[data-czc-scroll]', d);
              if (sc) sc.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
              restoreFocus(null);
              announce(addedText(j.items));
              dispatch('czc:added', { items: j.items || [] });
            });
          })
          .catch(function (err) {
            adding = false;
            addBtn.disabled = false;
            toast((err && err.message) || 'Oups, l’ajout n’a pas fonctionné. Réessayez.');
          });
      });
    }
  }

  /* ------------------------------------------------------------------------
     Clics
     ------------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var opener = t.closest('[data-czc-open]');
    if (opener && drawer()) {
      e.preventDefault();
      if (isOpen()) close(); else open({ returnFocus: opener });
      return;
    }
    if (t.closest('[data-czc-close]')) {
      e.preventDefault();
      close();
      return;
    }
    var q = t.closest('[data-czc-qty]');
    if (q && drawer() && drawer().contains(q)) {
      e.preventDefault();
      var line = parseInt(q.getAttribute('data-line'), 10);
      var qty = Math.max(0, parseInt(q.getAttribute('data-czc-qty'), 10) || 0);
      if (line) changeLine(line, qty, q);
    }
  });

  /* Le lien « panier » se comporte comme un bouton (touche Espace) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Spacebar') return;
    var t = e.target;
    if (t && t.matches && t.matches('a[data-czc-open]')) {
      e.preventDefault();
      t.click();
    }
  });

  /* ------------------------------------------------------------------------
     Démarrage
     ------------------------------------------------------------------------ */
  function boot() {
    var d = drawer();
    if (!d) return;
    initUpsell(d);
    setCount(parseInt(d.getAttribute('data-count'), 10) || 0);
    var flag = null;
    try {
      flag = window.sessionStorage.getItem('czc-open');
      window.sessionStorage.removeItem('czc-open');
    } catch (e) {}
    if (flag) setTimeout(function () { open(); }, 120);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Retour arrière (cache du navigateur) : on remet le panier à jour */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  /* Panier modifié ailleurs (actions standard Shopify, applications) : on le ré-affiche */
  ['shopify:cart:lines-update', 'shopify:cart:discount-update', 'cart:update'].forEach(function (name) {
    document.addEventListener(name, function () { if (!adding) refresh(); }, true);
  });

  /* Éditeur de thème */
  function inDrawerSection(e) { return e.target && e.target.querySelector && e.target.querySelector('[data-czc]'); }
  document.addEventListener('shopify:section:select', function (e) { if (inDrawerSection(e)) open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (inDrawerSection(e)) close(); });
  document.addEventListener('shopify:section:load', function (e) {
    if (!inDrawerSection(e)) return;
    docEl.classList.remove('czc-lock');
    initUpsell(e.target);
    var d = drawer();
    setCount(parseInt(d.getAttribute('data-count'), 10) || 0);
    open();
  });

  /* Page /cart : si le panier change depuis le panier latéral, on recharge la page */
  ['czc:updated', 'czc:added'].forEach(function (name) {
    document.addEventListener(name, function () {
      if (document.querySelector('[data-czc-cartpage]')) setTimeout(function () { window.location.reload(); }, 400);
    });
  });

  window.CzCart = { add: add, open: open, close: close, refresh: refresh, isOpen: isOpen, press: press };
})();
